import React from 'react';
import starV2 from './star-v2.svg';
import starFilledV2 from './star-filled-v2.svg';
import { ReviewType } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/ProductReviewGrid';

interface StarsV2Props {
  review: ReviewType;
}

/**
 * This Component is rendering stars (1 star => 5 stars) in the ProductReviewCard.
 */

const ReviewStarsV2 = ({ review }: StarsV2Props) => (
  <div>
    {[0, 1, 2, 3, 4].map((val, index) => (
      <svg
        key={val}
        style={{ width: '12px', height: '12px', marginRight: '4px', marginBottom: '2px' }}
        viewBox={review.stars > index ? starFilledV2.viewBox : starV2.viewBox}
      >
        <use href={`#${review.stars > index ? starFilledV2.id : starV2.id}`} />
      </svg>
    ))}
  </div>
);

export default ReviewStarsV2;
